<template>
	<img
		v-if="url && !failed"
		:src="url"
		:alt="alt"
		width="40"
		height="40"
		:class="{ 'is-loaded': loaded }"
		@load="loaded = true"
		@error="failed = true"
	/>
</template>

<style scoped>
img {
	visibility: hidden;
	width: 2.5rem;
	height: 2.5rem;
	object-fit: contain;
	padding: 2px;
	max-width: none;
}

img.is-loaded {
	visibility: visible;
}
</style>

<script setup>
import { computed, ref, watch } from 'vue';

import { get_image_url } from '../_partials/_utilities.js';
import { store } from './_store.js';

const props = defineProps({
	item: {
		type: Object,
		required: true,
	},
	logo_url_template: {
		type: String,
		required: false,
		default: null,
	},
});

const failed = ref(false);
const loaded = ref(false);

const url = computed(() => get_image_url(props.logo_url_template || store.logo_url_template, props.item));

const alt = computed(() => (props.item.company_name ? `${props.item.company_name} logo` : ``));

watch(url, () => {
	failed.value = false;
	loaded.value = false;
});
</script>
